"use client";
// ===================================================
// EnvStatesHeader — the "facts" row of the מצבים screen.
// Four cards (Local / Edit / Preview / Production) with role · branch · commit · status · time,
// plus the drift bar. Pure presentation over useEnvStates() data. Rule 10: reuses
// dev_status_items / dev_status_drift (no new tables).
// ===================================================
import { envFacts, type EnvItem, type EnvDrift, type EnvKey, ENVS } from "@/lib/environments-queries";

const ORDER: EnvKey[] = ["local", "edit", "preview", "production"];

export function EnvStatesHeader({ items, drift }: { items: EnvItem[]; drift: EnvDrift[] }) {
  return (
    <div dir="rtl" className="space-y-3">
      {/* drift bar — the same signal DevStatusBoard surfaces */}
      {drift.length > 0 ? (
        <div className="space-y-1">
          {drift.map((d, i) => (
            <div key={i} className={`text-xs rounded-lg px-3 py-1.5 border ${
              d.severity === "red"
                ? "bg-red-950/40 border-red-800 text-red-300"
                : "bg-yellow-950/30 border-yellow-800/60 text-yellow-300"}`}>
              {d.severity === "red" ? "🔴" : "🟡"} {d.message}
            </div>
          ))}
        </div>
      ) : (
        <div className="text-xs rounded-lg px-3 py-1.5 border bg-emerald-950/30 border-emerald-800/60 text-emerald-300">
          🟢 אפס drift — המצבים מסונכרנים
        </div>
      )}

      <div className="grid grid-cols-1 md:grid-cols-3 gap-3">
        {ORDER.map((env) => {
          const f = envFacts(env, items);
          return (
            <div key={env} className="bg-slate-800/30 rounded-xl border border-slate-700 p-4 space-y-2">
              <div className="flex items-center justify-between">
                <span className={`text-[11px] font-semibold rounded-md border px-2 py-0.5 ${ENVS[env].chip}`}>{f.label}</span>
                <span className="text-[11px] text-slate-500">{f.when}</span>
              </div>
              <p className="text-[11px] text-slate-400 -mt-1">{ENVS[env].tagline}</p>
              <div className="text-xs text-slate-300 flex justify-between gap-2"><span>ענף</span><b className="text-teal-300 truncate max-w-[60%]" dir="ltr">{f.branch}</b></div>
              <div className="text-xs text-slate-300 flex justify-between gap-2"><span>commit</span><b className="text-slate-200" dir="ltr">{f.commit}</b></div>
              <div className="text-xs text-slate-300 flex justify-between gap-2"><span>סטטוס</span><span>{f.status}</span></div>
              {f.link && (
                <a href={f.link} target="_blank" rel="noreferrer" className="text-[11px] text-teal-400 hover:underline">פתח במקור ↗</a>
              )}
              {f.empty && <div className="text-[11px] text-slate-500">ממתין לנתונים (טוקן/סנכרון)</div>}
              <p className="text-[10px] leading-tight text-amber-300/70 border-t border-white/5 pt-1.5">⚠ {ENVS[env].limitation}</p>
            </div>
          );
        })}
      </div>
    </div>
  );
}
